import type { getStakeProps } from '../types';

import { GameStake, getStake } from './helpers';

export default function isUltraStake({
  buyIn,
  currency,
  maxWinnerPayout,
  promoRef,
  rake,
  scalePM,
  isPlayMoney
}: getStakeProps): boolean {
  const isUltra: boolean =
    getStake({
      buyIn,
      currency,
      maxWinnerPayout,
      promoRef,
      rake,
      scalePM,
      isPlayMoney
    }) === GameStake.ULTRA;

  return isUltra;
}
